
import DashboardLayout from "@/components/DashboardLayout";
import DemoPageHeader from "@/components/DemoPageHeader";
import ReportsCharts from "@/components/ReportsCharts";
import ReportsSummaryCards from "@/components/ReportsSummaryCards";
import { DEMO_ORDERS, DEMO_PRODUCTS } from "@/utils/demoData";
import { useReportsAnalytics } from "@/hooks/useReportsAnalytics";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Sparkles, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const DemoReports = () => {
  // Use the same analytics hook with demo data
  const { analytics, formatPrice } = useReportsAnalytics(DEMO_ORDERS, []);

  return (
    <DashboardLayout>
      <DemoPageHeader
        title="Demo Reports & Analytics"
        description="Experience comprehensive insights and analytics for your Etsy business."
      >
        {/* Demo Banner */}
        <Card className="border-blue-200 bg-blue-50 mb-6">
          <CardContent className="p-4">
            <div className="flex items-start gap-3">
              <Sparkles className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" />
              <div className="flex-1">
                <h3 className="font-semibold text-blue-900 mb-1">Demo Analytics & Reports</h3>
                <p className="text-blue-800 text-sm mb-3">
                  Explore comprehensive analytics based on {DEMO_ORDERS.length} orders and {DEMO_PRODUCTS.length} products. 
                  See detailed charts, trends, and insights that would help optimize your actual business.
                </p>
                <Link to="/signup">
                  <Button size="sm" className="bg-blue-600 hover:bg-blue-700">
                    Get Real Analytics
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </Link>
              </div>
            </div>
          </CardContent>
        </Card>

        <ReportsSummaryCards analytics={analytics} formatPrice={formatPrice} />
        
        <div className="mt-6">
          <ReportsCharts analytics={analytics} formatPrice={formatPrice} />
        </div>
      </DemoPageHeader>
    </DashboardLayout>
  );
};

export default DemoReports;
